<template>
    <div
        :class="{ 'l-ss-c-offer-count-cart-wrapper': $configuration.cartCount.active && ($configuration.completionsFullWidth ||
            $configuration.layout.templateOffer !== 'rows'), 'l-ss-c-offer-cart-wrapper': !$configuration.cartCount.active }">
        <div
            v-if="$configuration.cartCount.active"
            class="l-ss-c-offer-count-cart">
            <div
                class="l-ss-c-offer-count-wrapper"
                v-if="count && quantityCartItem > 0"
                @click.prevent>
                <button
                    ref="add-cart-btn"
                    class="l-ss-c-offer-footer-action-add-to-cart-count"
                    :class="{ 'l-ss-c-offer-action-remove-from-cart-count-disabled': quantityCartItem < 1 }"
                    @click="minusCart()"
                    type="button">
                    <i
                        :class="{ 'l-ss-c-icon-success': isCartRemoveIconActive }"
                        class="l-ss-c-icon l-ss-c-icon-primary l-ss-c-icon-count-left"
                        v-html="minusIcon"></i>
                </button>
                <div class="l-ss-c-offer-count">
                    {{ quantityCartItem }}
                </div>
                <button
                    ref="add-cart-btn"
                    class="l-ss-c-offer-footer-action-add-to-cart-count"
                    @click="plusCart()"
                    type="button">
                    <i
                        class="l-ss-c-icon l-ss-c-icon-primary l-ss-c-icon-count-right"
                        v-html="plusIcon"></i>
                </button>
            </div>
            <div
                v-if="isCart() && quantityCartItem === 0"
                class="l-ss-c-offer-footer-actions"
                @click.prevent>
                <button
                    ref="add-cart-btn"
                    class="l-ss-c-offer-footer-action-add-to-cart"
                    :class="{ 'l-ss-c-offer-footer-action-add-to-cart-button--is-active': isCheckedIdAddToCard(offer.id) }"
                    @click="addToCart"
                    type="button">
                    {{ $t('results.toCart') }}
                </button>
                <button
                    class="rr-item-bottom-wrapper__button--mobile"
                    ref="add-cart-btn"
                    @click="addToCart">
                    <span class="icon">
                        <svg
                            fill="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M11 9h2V6h3V4h-3V1h-2v3H8v2h3v3zm-4 9c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-8.9-5h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.42 4l-3.87 7H8.53L4.27 2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2z"/>
                        </svg>
                    </span>
                </button>
            </div>
            <div
                v-if="!isCart() && isOffer()"
                class="l-ss-c-offer-footer-actions">
                <a
                    href="javascript:;"
                    @click="openNotifyModal"
                    class="l-ss-c-offer-footer-action-add-to-cart l-ss-c-offer-footer-action-notify">
                    Уведомить
                </a>
                <a
                    href="javascript:;"
                    @click="openNotifyModal"
                    aria-label="Уведомить о&nbsp;поступлении"
                    class="l-ss-c-offer-footer-action-notify-mobile">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 24 24">
                        <path d="M10.01 21.01c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99zM12 6c2.76 0 5 2.24 5 5v7H7v-7c0-2.76 2.24-5 5-5m0-4.5c-.83 0-1.5.67-1.5 1.5v1.17C7.36 4.85 5 7.65 5 11v6l-2 2v1h18v-1l-2-2v-6c0-3.35-2.36-6.15-5.5-6.83V3c0-.83-.67-1.5-1.5-1.5M13 8h-2v3H8v2h3v3h2v-3h3v-2h-3z"/>
                    </svg>
                </a>
            </div>
        </div>
        <button
            v-if="!$configuration.cartCount.active && showCartButton"
            ref="add-cart-btn"
            class="l-ss-c-offer-footer-action-add-to-cart"
            type="button"
            :class="{ 'l-ss-c-offer-footer-action-add-to-cart--is-active': isCheckedIdAddToCard(offer.id) }"
            @click.prevent="addToCart(offer)"
            @touchstart.prevent="addToCart(offer)">
            <i
                class="l-ss-c-icon l-ss-c-icon-primary"
                v-html="cartIcon"></i>
        </button>
    </div>
</template>

<script>
    import minusIcon from '@/core/assets/images/icons/minus_icon.svg';
    import plusIcon from '@/core/assets/images/icons/plus_icon.svg';
    import cartIcon from '@/core/assets/images/icons/add-to-cart.svg';

    export default {
        props: ['showCartButton','offer','count','completion'],
        data() {
            return {
                isCartRemoveIconActive: false,
                quantityCartItem: window.sbLayer.getCartProductQuantity(this.offer.id) ?? 0,
                offerCart: 0,
                durationInterval: 0,
                offersIdsAddToCard: [],
            };
        },
        computed: {
            /*
             * Это понадобится когда будем делать дополнительные настройки
             * c сохранением состояния
             * cashOfferCartCount() {
             *    return Number(localStorage.getItem(`${this.offer?.id}_cash`));
             * },
             * storageQuantityCartItem() {
             *    return Number(localStorage.getItem(this.offer?.id));
             * },
             */
            offerCartCount() {
                if (this.offerCart) {
                    return (this.offerCart.length) ? this.offerCart[0].quantity : this.quantityCartItem;
                }
                return this.quantityCartItem;
            },
            minusIcon() {
                return minusIcon;
            },
            plusIcon() {
                return plusIcon;
            },
            cartIcon() {
                return cartIcon;
            },
        },
        mounted() {
            /*
             * Это понадобится когда будем делать дополнительные настройки
             * c сохранением состояния
             *
             * if (this.cashOfferCartCount !== this.offerCartCount) {
             *     this.quantityCartItem = this.offerCartCount;
             *     localStorage.setItem(`${this.offer?.id}_cash` , this.offerCartCount);
             *     localStorage.setItem(this.offer?.id , this.quantityCartItem);
             * } else {
             *     this.quantityCartItem = (this.storageQuantityCartItem) ? this.storageQuantityCartItem : this.offerCartCount;
             *     localStorage.setItem(`${this.offer?.id}_cash` , this.offerCartCount);
             * }
             */

            /*
             * const cartStatus = () => {
             *     return (this.$configuration.cartStatus) ? this.$configuration.cartStatus() : {};
             * };
             */

            // this.durationInterval = (cartStatus().duration || cartStatus().duration === 0) ? cartStatus().duration : this.durationInterval;

            /*
             * if (cartStatus().getCartStatus) {
             *     this.offerCart = this.getQuantityOffer();
             * }
             */

            // this.quantityCartItem = this.offerCartCount;

            /*
             * if (this.durationInterval !== 0) {
             *     setInterval(() => {
             *         if (cartStatus().getCartStatus) {
             *             this.offerCart = this.getQuantityOffer();
             *         }
             *         this.quantityCartItem = this.offerCartCount;
             *     }, this.durationInterval);
             * }
             */
        },
        
        methods: {
            getQuantityOffer() {
                if (this.$configuration.cartStatus) {
                    return this.$configuration.cartStatus().getCartStatus.filter(offer => offer?.id === this.offer?.id);
                }
                return this.offerCart;
            },
            emitsQuery(payload, actionName) {
                const { id, name, price , img , url } = payload;
                localStorage.setItem(id , this.quantityCartItem);
                this.$emit( actionName, {
                    id: id,
                    name: (name || '').replace(/<\/?[^>]+(>|$)/g, ''),
                    price: parseFloat(price),
                    quantity: this.quantityCartItem,
                    img: img,
                    url: url,
                    data: payload,
                });
            },
            plusCart() {
                this.quantityCartItem++;
                window.sbLayer.setCartProductQuantity(this.offer.id, this.quantityCartItem);
            },

            minusCart() {
                if (this.quantityCartItem > -1) {
                    this.quantityCartItem--;
                }
                window.sbLayer.setCartProductQuantity(this.offer.id, this.quantityCartItem);
            },

            isCheckedIdAddToCard(offerId) {
                return this.offersIdsAddToCard.includes(offerId);
            },

            checkedAddToCard(offerId) {
                const checked = this.isCheckedIdAddToCard(offerId);

                if (!checked) {
                    this.offersIdsAddToCard.push(offerId);
                } else {
                    return;
                }
            },

            addToCart() {
                this.checkedAddToCard(this.offer.id);

                this.emitsQuery(this.offer , 'add-to-cart');
                window.sbLayer.addProductToCart(this.offer.id, 1);
                this.quantityCartItem++;
            },
            isCart() {
                if (!this.offer.data) {
                    return this.offer.available;
                } else {
                    return this.offer.data.offer.available;
                }
            },
            openNotifyModal() {
                window.sbLayer.onNotifyMeButtonClick(this.offer.id);
            },
            isOffer() {
                if (this.completion) {
                    if (this.offer.data.label === 'offers' || this.offer.data.label === 'extra_offer') {
                        return true;
                    } else {
                        return false;
                    }
                }
                return true;
            },
        },
    };
</script>
